/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import PermissionTypes from "./model/constants/permissionTypes";
import { isGranted } from "./utils/auth";
import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          name: "home",
          component: () => import("@/views/pages/Dashboard/Dashboard.vue"),
          meta: {
            rule: "editor",
            permissions: [PermissionTypes.Permissions_Administrator],
          },
        },

        // =============================================================================
        // Application Routes
        // =============================================================================
        /*{
          path: '/apps/todo',
          redirect: '/apps/todo/all'
        },
        {
          path: '/apps/todo/:filter',
          name: 'todo',
          component: () => import('./views/apps/todo/Todo.vue'),
          meta: {
            rule: 'editor',
            parent: "todo"
          }
        },*/

        // =============================================================================
        // Pages Routes
        // =============================================================================
        {
          path: "/pages/roles",
          name: "page-roles",
          component: () => import("@/views/pages/Role/Roles.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Roller",
                active: true,
              },
            ],
            pageTitle: "Roller Listesi",
            rule: "editor",
          },
        },
        {
          path: "/pages/users",
          name: "page-users",
          component: () => import("@/views/pages/User/Users.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Kullanıcılar",
                active: true,
              },
            ],
            pageTitle: "Kullanıcılar Listesi",
            rule: "editor",
          },
        },
        {
          path: "/pages/MonthlyStockTransfer",
          name: "page-monthly-stock-transfer",
          component: () =>
            import(
              "@/views/pages/MonthlyStockTransfer/MonthlyStockTransfer.vue"
            ),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Stoklar",
                active: true,
              },
            ],
            pageTitle: "Ay Sonu Stok Sayımı ve Devir",
            rule: "editor",
          },
        },
        {
          path: "/pages/Targets",
          name: "page-targets",
          component: () => import("@/views/pages/Target/Targets.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Hedefler",
                active: true,
              },
            ],
            pageTitle: "Hedefler",
            rule: "editor",
          },
        },
        {
          path: "/pages/Branchs",
          name: "page-branchs",
          component: () => import("@/views/pages/Branch/Branchs.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Şubeler",
                active: true,
              },
            ],
            pageTitle: "Şubeler Listesi",
            rule: "editor",
          },
        },
        {
          path: "/pages/BranchsProductList",
          name: "page-BranchsProductList",
          component: () =>
            import("@/views/pages/Branch/BranchsProductList.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Şubeler",
                active: true,
              },
            ],
            pageTitle: "Şubeler Fiyat Listesi",
            rule: "editor",
          },
        },
        {
          path: "/pages/PriceLists",
          name: "page-PriceLists",
          component: () => import("@/views/pages/Product/PriceLists.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Fiyat Listeleri",
                active: true,
              },
            ],
            pageTitle: "Fiyat Listeleri",
            rule: "editor",
          },
        },
        {
          path: "/pages/StockOrder",
          name: "page-stock-order",
          component: () => import("@/views/pages/StockOrder/StockOrders.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Stok Siparişleri",
                active: true,
              },
            ],
            pageTitle: "Stok Siparişleri",
            rule: "editor",
            props: true,
          },
        },
        {
          path: "/pages/kitchens",
          name: "page-kitchens",
          component: () => import("@/views/pages/Kitchen/Kitchens.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Mutfaklar",
                active: true,
              },
            ],
            pageTitle: "Mutfaklar",
            rule: "editor",
            props: true,
          },
        },
        {
          path: "/pages/integrations",
          name: "page-integrations",
          component: () => import("@/views/pages/Integration/Integrations.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Entegrasyonlar",
                active: true,
              },
            ],
            pageTitle: "Entegrasyonlar",
            rule: "editor",
            props: true,
          },
        },
        {
          path: "/pages/integration/:slug",
          name: "integration-detail",
          component: () =>
            import("@/views/pages/Integration/IntegrationDetail.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              { title: "Anasayfa", url: "/" },
              { title: "Entegrasyonlar", url: "/pages/integrations" },
              { title: "Detay", active: true },
            ],
            pageTitle: "Entegrasyon Detayı",
            rule: "editor",
          },
        },
        {
          path: "/pages/suppliers",
          name: "page-suppliers",
          component: () => import("@/views/pages/Supplier/Suppliers.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Tedarikçiler",
                active: true,
              },
            ],
            pageTitle: "Tedarikçiler",
            rule: "editor",
          },
        },
        {
          path: "/pages/products",
          name: "page-products",
          component: () => import("@/views/pages/Product/Products.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ürünler",
              },
              {
                title: "Ürün Listesi",
                active: true,
              },
            ],
            pageTitle: "Ürün Listesi",
            rule: "editor",
          },
        },
        {
          path: "/pages/productSizes",
          name: "page-product-sizes",
          component: () => import("@/views/pages/ProductSize/ProductSizes.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ürünler",
              },
              {
                title: "Boy Listesi",
                active: true,
              },
            ],
            pageTitle: "Boy Listesi",
            rule: "editor",
          },
        },
        {
          path: "/pages/productCategories",
          name: "page-product-categories",
          component: () =>
            import("@/views/pages/ProductCategory/ProductCategory.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ürünler",
              },
              {
                title: "Ürün Kategori Listesi",
                active: true,
              },
            ],
            pageTitle: "Ürün Kategori Listesi",
            rule: "editor",
          },
        },
        {
          path: "/pages/bills",
          name: "page-bills",
          component: () => import("@/views/pages/Bill/Bills.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Stoklar",
              },
              {
                title: "Faturalarım",
                active: true,
              },
            ],
            pageTitle: "Faturalarım",
            rule: "editor",
          },
        },
        {
          path: "/pages/stocks",
          name: "page-stocks",
          component: () => import("@/views/pages/Stock/Stocks.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ürünler",
              },
              {
                title: "Stok Listesi",
                active: true,
              },
            ],
            pageTitle: "Stok Listesi",
            rule: "editor",
          },
        },
        {
          path: "/pages/units",
          name: "page-units",
          component: () => import("@/views/pages/Unit/Units.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Birimler",
              },
              {
                title: "Birim Listesi",
                active: true,
              },
            ],
            pageTitle: "Birim Listesi",
            rule: "editor",
          },
        },
        {
          path: "/pages/rawMaterials",
          name: "page-raw-materials",
          component: () => import("@/views/pages/RawMaterial/RawMaterials.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ürünler",
              },
              {
                title: "Hammaddeler",
                active: true,
              },
            ],
            pageTitle: "Hammaddeler",
            rule: "editor",
          },
        },
        {
          path: "/pages/rawMaterialCategories",
          name: "page-raw-material-categories",
          component: () =>
            import("@/views/pages/RawMaterialCategory/RawMaterialCategories"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ürünler",
              },
              {
                title: "Hammadde Kategorileri",
                active: true,
              },
            ],
            pageTitle: "Hammaddeler Kategorileri",
            rule: "editor",
          },
        },
        {
          path: "/pages/halfMadeProducts",
          name: "page-half-made-products",
          component: () =>
            import("@/views/pages/HalfMadeProduct/HalfMadeProducts.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ürünler",
              },
              {
                title: "Yarı Mamüller",
                active: true,
              },
            ],
            pageTitle: "Yarı Mamüller",
            rule: "editor",
          },
        },
        {
          path: "/pages/campaign",
          name: "page-campaign",
          component: () => import("@/views/pages/Campaign/Campaigns.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Kampanyalar",
                active: true,
              },
            ],
            pageTitle: "Kampanyalar",
            rule: "editor",
          },
        },
        {
          path: "/pages/table-editor",
          name: "page-table-editor",
          component: () => import("@/views/pages/TableEditors/TableEditor.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Tablo Editörü",
                active: true,
              },
            ],
            pageTitle: "Tablo Editörü",
            rule: "editor",
          },
        },
        {
          path: "/pages/table-editor2",
          name: "page-table-editor2",
          component: () =>
            import("@/views/pages/TableEditors/TableEditor2.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Masa Düzeni Editörü 2",
                active: true,
              },
            ],
            pageTitle: "Masa Düzeni Editörü 2",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/BranchComparativeReport",
          name: "page-branch-comparative-report",
          component: () =>
            import(
              "@/views/pages/Reports/ComparativeReport/ComparativeBranchReport"
            ),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Şube Karşılaştırma",
                active: true,
              },
            ],
            pageTitle: "Şube Karşılaştırma",
            rule: "editor",
          },
        },
        {
          path: "/pages/draws",
          name: "page-draw",
          component: () => import("@/views/pages/Draw/Draws.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Çekilişler",
                active: true,
              },
            ],
            pageTitle: "Çekilişler",
            rule: "editor",
          },
        },
        {
          path: "/pages/CustomerTickets",
          name: "page-customer-tickets",
          component: () => import("@/views/pages/Draw/CustomerTickets"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Kullanıcı Biletleri",
                active: true,
              },
            ],
            pageTitle: "Kullanıcı Biletleri",
            rule: "editor",
          },
        },
        {
          path: "/pages/recipes",
          name: "page-recipes",
          component: () => import("@/views/pages/Recipe/Recipes.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ürünler",
              },
              {
                title: "Reçeteler",
                active: true,
              },
            ],
            pageTitle: "Reçeteler",
            rule: "editor",
          },
        },
        {
          path: "/pages/distributors",
          name: "page-distributors",
          component: () => import("@/views/pages/Distributor/Distributors.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Tedarikçiler",
              },
              {
                title: "Distribütörler",
                active: true,
              },
            ],
            pageTitle: "Distribütörler",
            rule: "editor",
          },
        },
        {
          path: "/pages/orderLogs",
          name: "page-order-logs",
          component: () =>
            import("@/views/pages/OrderLog/OrderLog/OrderLogs.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Sıcak Satış Kayıtlar",
                active: true,
              },
            ],
            pageTitle: "Sıcak Satış Kayıtları",
            rule: "editor",
          },
        },
        {
          path: "/pages/expenseDefinitions",
          name: "page-expense-definitions",
          component: () =>
            import("@/views/pages/ExpenseDefinition/ExpenseDefinitions.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Gider Tipleri",
              },
              {
                title: "Gider Tipleri",
                active: true,
              },
            ],
            pageTitle: "Gider Tipleri",
            rule: "editor",
          },
        },
        {
          path: "/pages/blackLists",
          name: "page-black-lists",
          component: () => import("@/views/pages/BlackList/BlackLists.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Yasaklı Kullanıcılar",
              },
              {
                title: "Yasaklı Kullanıcılar",
                active: true,
              },
            ],
            pageTitle: "Yasaklı Kullanıcılar",
            rule: "editor",
          },
        },
        {
          path: "/pages/userwant",
          name: "userwant",
          component: () => import("@/views/pages/UserWants/UserWant.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Kullanıcı İstekleri",
              },
              {
                title: "Kullanıcı İstekleri",
                active: true,
              },
            ],
            pageTitle: "Kullanıcı İstekleri",
            rule: "editor",
          },
        },
        {
          path: "/pages/roles",
          name: "page-role-lists",
          component: () => import("@/views/pages/Role/Roles.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Roller",
              },
              {
                title: "Roller",
                active: true,
              },
            ],
            pageTitle: "Roller",
            rule: "editor",
          },
        },
        {
          path: "/pages/losses",
          name: "page-losses",
          component: () => import("@/views/pages/Loss/Losses.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Zayiat",
              },
              {
                title: "Zayiatlar",
                active: true,
              },
            ],
            pageTitle: "Zayiatlar",
            rule: "editor",
          },
        },
        {
          path: "/pages/lossReasons",
          name: "page-loss-reasons",
          component: () => import("@/views/pages/LossReason/LossReasons.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Zayiat",
              },
              {
                title: "Zayiat Sebepleri",
                active: true,
              },
            ],
            pageTitle: "Zayiat Sebepleri",
            rule: "editor",
          },
        },
        {
          path: "/pages/totalOrderLogs",
          name: "page-total-order-logs",
          component: () =>
            import("@/views/pages/OrderLog/TotalOrderLogs/TotalOrderLogs.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Sıcak Satış Kayıtları",
              },
              {
                title: "Toplam Ciro Raporu",
                active: true,
              },
            ],
            pageTitle: "Toplam Ciro Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/expenses",
          name: "page-expenses",
          component: () => import("@/views/pages/Expense/Expenses.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Sıcak Satış Kayıtları",
              },
              {
                title: "Giderlerim",
                active: true,
              },
            ],
            pageTitle: "Giderlerim",
            rule: "editor",
          },
        },
        {
          path: "/pages/discount",
          name: "page-discount",
          component: () => import("@/views/pages/Discount/Discount.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Sıcak Satış Kayıtları",
              },
              {
                title: "İndirimler",
                active: true,
              },
            ],
            pageTitle: "İndirimler",
            rule: "editor",
          },
        },
        {
          path: "/pages/discountReason",
          name: "page-discount-reason",
          component: () => import("@/views/pages/Discount/DiscountReason.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Sıcak Satış Kayıtları",
              },
              {
                title: "İndirimler",
                active: true,
              },
            ],
            pageTitle: "İndirim Sebepleri",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/branch-report",
          name: "page-branch-report",
          component: () =>
            import(
              "@/views/pages/Reports/BranchOrPersonalGiro/BranchOrPersonalGiro.vue"
            ),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Şube Raporu",
                active: true,
              },
            ],
            pageTitle: "Şube Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/category-report",
          name: "page-category-report",
          component: () =>
            import("@/views/pages/Reports/CategoryGiro/CategoryGiro.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Kategori Ciro Raporu",
                active: true,
              },
            ],
            pageTitle: "Kategori Ciro Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/product-report",
          name: "page-product-report",
          component: () =>
            import("@/views/pages/Reports/ProductGiro/ProductGiro.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Ürün Ciro Raporu",
                active: true,
              },
            ],
            pageTitle: "Ürün Ciro Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/cari-report",
          name: "page-cari-report",
          component: () =>
            import("@/views/pages/Reports/CariReport/CariReport.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Cari Raporu",
                active: true,
              },
            ],
            pageTitle: "Cari Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/giro-by-time",
          name: "page-giro-by-time",
          component: () =>
            import("@/views/pages/Reports/GiroByTime/GiroByTime.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Zamana Göre Ciro Raporu",
                active: true,
              },
            ],
            pageTitle: "Zamana Göre Ciro Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/giro-by-date",
          name: "page-giro-by-date",
          component: () =>
            import("@/views/pages/Reports/GiroByDate/GiroByDate.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Tarihe Göre Ciro Raporu",
                active: true,
              },
            ],
            pageTitle: "Tarihe Göre Ciro Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/raw-material-consumption",
          name: "raw-material-consumption",
          component: () =>
            import(
              "@/views/pages/Reports/RawMaterialConsumption/RawMaterialConsumption.vue"
            ),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Hammadde Tüketim Raporu",
                active: true,
              },
            ],
            pageTitle: "Hammadde Tüketim Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/wallet-transaction",
          name: "wallet-transaction",
          component: () =>
            import(
              "@/views/pages/Reports/WalletTransaction/WalletTransactionReport.vue"
            ),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Cüzdan Raporu",
                active: true,
              },
            ],
            pageTitle: "Cüzdan Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/day-report",
          name: "day-report",
          component: () =>
            import("@/views/pages/Reports/DayReports/DayReport.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Gün Sonu Raporu",
                active: true,
              },
            ],
            pageTitle: "Gün Sonu Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/z-report",
          name: "z-report",
          component: () =>
            import("@/views/pages/Reports/DayReports/ZReport.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Z Raporu",
                active: true,
              },
            ],
            pageTitle: "Z Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/wallet-offset",
          name: "wallet-offset",
          component: () =>
            import(
              "@/views/pages/Reports/WalletOfSetting/WalletOfSettingReport.vue"
            ),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Şube Mahsuplaşma",
                active: true,
              },
            ],
            pageTitle: "Şube Mahsuplaşma",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/wallet-accouting-report",
          name: "wallet-offaccounting",
          component: () =>
            import(
              "@/views/pages/Reports/WalletOfSetting/WalletAccountingReport.vue"
            ),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Cüzdan Muhasebe Raporu",
                active: true,
              },
            ],
            pageTitle: "Cüzdan Muhasebe Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/customer-mood-report",
          name: "customer-mood-report",
          component: () =>
            import("@/views/pages/Reports/MoodReports/CustomerMoodReport"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Kullanıcı Mood Raporu",
                active: true,
              },
            ],
            pageTitle: "Kullanıcı Mood Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/branch-balance-report",
          name: "branch-balance-report",
          component: () =>
            import("@/views/pages/Reports/MoodReports/BranchBalanceReport"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Şube Bakiye Raporu",
                active: true,
              },
            ],
            pageTitle: "Şube Bakiye Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/campaign-gift-report",
          name: "campaign-gift-report",
          component: () =>
            import("@/views/pages/Reports/CampaignGift/CampaignGiftReport"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Kampanya Hediye Raporu",
                active: true,
              },
            ],
            pageTitle: "Kampanya Hediye Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/inventory-report",
          name: "page-inventory-report",
          component: () =>
            import("@/views/pages/Reports/InventoryReport/InventoryReport.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Envanter Raporu",
                active: true,
              },
            ],
            pageTitle: "Envanter Raporu",
            rule: "editor",
          },
        },
        {
          path: "/pages/reports/staff-action-report",
          name: "page-staff-action-report",
          component: () =>
            import(
              "@/views/pages/Reports/StaffActionReport/StaffActionReport.vue"
            ),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Raporlar",
              },
              {
                title: "Personel İşlem Raporu",
                active: true,
              },
            ],
            pageTitle: "Personel İşlem Raporu",
            rule: "editor",
            permissions: [PermissionTypes.staff_action_report_read],
          },
        },
        {
          path: "/pages/payment-methods",
          name: "page-payment-methods",
          component: () =>
            import("@/views/pages/PaymentMethod/PaymentMethods.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ödeme Tipi",
              },
              {
                title: "Ödeme Tipleri",
                active: true,
              },
            ],
            pageTitle: "Ödeme Tipleri",
            rule: "editor",
          },
        },
        {
          path: "/pages/ProductExtras",
          name: "page-product-extras",
          component: () =>
            import("@/views/pages/ProductExtra/ProductExtras.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ürünler",
              },
              {
                title: "Ekstralar",
                active: true,
              },
            ],
            pageTitle: "Ekstralar",
            rule: "editor",
          },
        },
        {
          path: "/pages/stock-transfer-blocker",
          name: "page-stock-transfer-blocker",
          component: () => import("@/views/pages/StockTransferBlocker"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            rule: "editor",
          },
        },
        {
          path: "/pages/moodfelek-settings",
          name: "page-moodfelek-settings",
          component: () =>
            import("@/views/pages/Settings/MoodFelekSettings.vue"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ayarlar",
              },
              {
                title: "Moodfelek Ayarları",
                active: true,
              },
            ],
            pageTitle: "Moodfelek Ayarları",
            rule: "editor",
          },
        },
        {
          path: "/pages/app-settings",
          name: "page-app-settings",
          component: () => import("@/views/pages/Settings/AppSettings"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ayarlar",
              },
              {
                title: "Panel Ayarları",
                active: true,
              },
            ],
            pageTitle: "Panel Ayarları",
            rule: "editor",
          },
        },
        {
          path: "/pages/MoodImage",
          name: "page-mood-image",
          component: () =>
            import("@/views/pages/MoodProfileImages/MoodProfileImage"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Ayarlar",
              },
              {
                title: "Mood Resim Ayarları",
                active: true,
              },
            ],
            pageTitle: "Mood Resim Ayarları",
            rule: "admin",
          },
        },
        // {
        //   path: '/pages/mobile-settings',
        //   name: 'page-mobile-settings',
        //   component: () => import('@/views/pages/Settings/MobileSettings'),
        //   meta: {
        //     permissions: [PermissionTypes.Permissions_Administrator],
        //     breadcrumb: [{
        //       title: 'Anasayfa',
        //       url: '/'
        //     },
        //       {
        //         title: 'Ayarlar',
        //       },
        //       {
        //         title: 'Mobil Ayarları',
        //         active: true
        //       },
        //     ],
        //     pageTitle: 'Mobil Ayarları',
        //     rule: 'editor'
        //   },
        // },
        {
          path: "/pages/pos-settings",
          name: "page-pos-settings",
          component: () => import("@/views/pages/Settings/PosSettings"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Pos Ayarları",
                active: true,
              },
            ],
            pageTitle: "Pos Ayarları",
            rule: "editor",
          },
        },
        {
          path: "/pages/printer-settings",
          name: "page-printer-settings",
          component: () => import("@/views/pages/Settings/PrinterSettings"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Yazıcı Ayarları",
                active: true,
              },
            ],
            pageTitle: "Yazıcı Ayarları",
            rule: "editor",
          },
        },
        {
          path: "/pages/kuver-settings",
          name: "page-kuver-settings",
          component: () => import("@/views/pages/Settings/KuverSetting"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Kuver Ayarları",
                active: true,
              },
            ],
            pageTitle: "Kuver Ayarları",
            rule: "editor",
          },
        },
        {
          path: "/pages/all-pos-settings",
          name: "page-all-pos-settings",
          component: () => import("@/views/pages/Settings/AllPosSettings"),
          meta: {
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Pos Ayarları",
                active: true,
              },
            ],
            pageTitle: "Pos Ayarları",
            rule: "editor",
          },
        },
        // Cari Hesaplar rotası ekleniyor
        {
          path: "/pages/cari",
          name: "page-cari",
          component: () => import("@/views/pages/Cari/Cari.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Cari Hesaplar", active: true },
            ],
            pageTitle: "Cari Hesaplar",
            rule: "editor",
          },
        },
        // QR Menü rotası ekleniyor
        {
          path: '/pages/qr-menu',
          name: 'page-qr-menu',
          component: () => import('@/views/pages/QRMenu/QRMenu.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'QR Menü', active: true },
            ],
            pageTitle: 'QR Menü',
            rule: 'editor'
          },
        },

        // =============================================================================
        // CHARTS & MAPS
        // =============================================================================
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/pages/selfservice",
          name: "page-self-service",
          component: () => import("@/views/pages/SelfService/SelfService.vue"),
          meta: {
            //notPermissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Satış Ekranı",
              },
              {
                title: "Satış Ekranı",
                active: true,
              },
            ],
            pageTitle: "Satış Ekranı",
            rule: "editor",
          },
        },
        {
          path: "/pages/selfservice2",
          name: "page-self-service2",
          component: () =>
            import("@/views/pages/SelfServiceWithoutTable/SelfService.vue"),
          meta: {
            //notPermissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Satış Ekranı",
              },
              {
                title: "Satış Ekranı",
                active: true,
              },
            ],
            pageTitle: "Satış Ekranı",
            rule: "editor",
          },
        },
        {
          path: "/pages/kiosk",
          name: "page-kiosk",
          component: () =>
            import("@/views/pages/Kiosk/KioskOrder.vue"),
          meta: {
            pageTitle: "Kiosk",
            rule: "editor",
          },
        },
        {
          path: "/pages/selfservice-select",
          name: "page-self-service-select",
          component: () =>
            import("@/views/pages/SelfService/SelfServiceSelect.vue"),
          meta: {
            //notPermissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Anasayfa",
                url: "/",
              },
              {
                title: "Sıcak Satış Seçimi",
              },
              {
                title: "Sıcak Satış Seçimi",
                active: true,
              },
            ],
            pageTitle: "Sıcak Satış Seçimi",
            rule: "editor",
          },
        },
        {
          path: "/pages/bis-login",
          name: "bis-login",
          component: () => import("@/views/pages/Login/BisLogin.vue"),
          meta: {
            rule: "editor",
          },
        },
        {
          path: "/pages/login",
          name: "page-login",
          component: () => import("@/views/pages/Login/Login.vue"),
          meta: {
            rule: "editor",
          },
        },
        {
          path: "/pages/MobileOrder",
          name: "page-MobileOrder",
          component: () => import("@/views/pages/SelfService/MobileOrder.vue"),
          meta: {
            //permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "MobileOrder",
                active: true,
              },
            ],
            pageTitle: "MobileOrder",
            rule: "editor",
          },
        },
        {
          path: "/pages/forgot-password",
          name: "page-forgot-password",
          component: () => import("@/views/pages/Login/ForgotPassword.vue"),
          meta: {
            rule: "editor",
          },
        },
        {
          path: "/pages/Cis",
          name: "Cis",
          component: () => import("@/views/pages/Cis/Cis.vue"),
          meta: {
            rule: "editor",
          },
        },
        {
          path: "/pages/reset-password",
          name: "page-reset-password",
          component: () => import("@/views/pages/Login/ResetPassword.vue"),
          meta: {
            rule: "editor",
          },
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
          meta: {
            rule: "editor",
          },
        },
        {
          path: "/pages/error-500",
          name: "page-error-500",
          component: () => import("@/views/pages/Error500.vue"),
          meta: {
            rule: "editor",
          },
        },
        {
          path: "/pages/not-authorized",
          name: "page-not-authorized",
          component: () => import("@/views/pages/NotAuthorized.vue"),
          meta: {
            rule: "editor",
          },
        },
        {
          path: "/pages/maintenance",
          name: "page-maintenance",
          component: () => import("@/views/pages/Maintenance.vue"),
          meta: {
            rule: "editor",
          },
        },
      ],
    },
    {
      path: "/pages/customer-screen",
      name: "page-customer-screen",
      component: () =>
        import("@/views/pages/SelfServiceWithoutTable/CustomerScreen.vue"),
      meta: {
        rule: "editor",
      },
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404",
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});
let beforeRouting = {
  to: null,
  from: null,
};
router.beforeEach((to, from, next) => {
  if (
    ((from.name === "page-stock-transfer-blocker" &&
      to.name !== "page-login") ||
      (to === beforeRouting.to && from === beforeRouting.from)) &&
    store.getters.getNeedStockTransfer
  )
    return;
  if (
    (to.name === from.name
      ? to.name !== "page-stock-transfer-blocker"
      : true) &&
    ((to.name === "page-stock-transfer-blocker" &&
      from.name === "page-self-service") ||
      (to.name !== "page-login" && to.name !== "page-stock-transfer-blocker"))
  ) {
    store.dispatch("setNeedStockTransfer").then(() => {
      if (store.getters.getNeedStockTransfer) {
        router.push({
          path: "/pages/stock-transfer-blocker",
          query: {
            to: to.path,
          },
        });
      } else {
        if (to.matched.some((record) => record.meta.permissions)) {
          //TODO if Auth next() else redirect to login
          let isGrantedPermission = false;
          to.meta.permissions.forEach((item) => {
            if (isGranted(item)) {
              isGrantedPermission = true;
            } ////////middleware
          });
          if (isGrantedPermission) {
            next();
          } else {
            router.push({
              path: "/pages/login",
              query: {
                to: to.path,
              },
            });
          }
        }
        if (to.matched.some((record) => record.meta.notPermissions)) {
          let isGrantedPermission = true;
          to.meta.notPermissions.forEach((item) => {
            if (isGranted(item)) {
              isGrantedPermission = false;
            } ////////middleware
          });
          if (isGrantedPermission) {
            next();
          } else {
            router.push({
              path: "/pages/login",
              query: {
                to: to.path,
              },
            });
          }
        }
        beforeRouting.to = to;
        beforeRouting.from = from ? from : to;
        next();
      }
    });
  } else {
    if (to.matched.some((record) => record.meta.permissions)) {
      //TODO if Auth next() else redirect to login
      let isGrantedPermission = false;
      to.meta.permissions.forEach((item) => {
        if (isGranted(item)) {
          isGrantedPermission = true;
        } ////////middleware
      });
      if (isGrantedPermission) {
        next();
      } else {
        router.push({
          path: "/pages/login",
          query: {
            to: to.path,
          },
        });
      }
    }
    beforeRouting.to = to;
    beforeRouting.from = from ? from : to;
    next();
  }
});

export default router;
